<!--升降急记录-->
<template lang="pug">
    <el-dialog title="升降级记录" width="80%" :close-on-click-modal='false' :append-to-body="true" :visible.sync='visible' :modal-append-to-body='false'>
        <div class="container">
            <div>姓名:{{ objectParams.name }}</div>
            <div>账号:{{ objectParams.mobile }}</div>
            <div>身份证件:{{ objectParams.idCard }}</div>
            <div>性别:{{ objectParams.gender ? '女' : '男' }}</div>
            <div>总场次:{{ objectParams.count || 0 }}</div>
            <div>总积分:{{ objectParams.point || 0 }}</div>
            <div>年度积分:{{ objectParams.yearScore || 0 }}</div>
            <div>季度积分:{{ objectParams.quarterScore || 0 }}</div>
        </div>
        el-table(:data="tableData" style="width: 100%" border)
                el-table-column(prop='afterLevel',header-align='center',align='center',label='新级别' )
                el-table-column(prop='beforeLevel',header-align='center',align='center',label='老级别' )
                el-table-column(prop='createTime',header-align='center',align='center',label='级别变更时间' )
                el-table-column(prop='createUserName',header-align='center',align='center',label='操作方' )
                el-table-column(header-align='center',align='center',label='比赛记录' )
                    template(slot-scope="scope")
                       <el-button type="text" @click="viewGameDetail(scope.row.id)">查看详情</el-button>
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 30]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">返回</el-button>
        </span>
        game-detail-recorde(v-if='gameDetailVisible', ref='gameDetail')
    </el-dialog>
</template>
<script>
import GameDetailRecorde from './game-detail-recorde'
export default {
    name: 'DownGradeRecorde',
    data () {
        return {
            memberId: '',
            visible: false,
            pageSize: 10,
            pageIndex: 1,
            tableData: [],
            totalPage: 0,
            objectParams: {},
            gameDetailVisible: false
        }
    },
    components: {
        GameDetailRecorde
    },
    methods: {
        viewGameDetail (id) {
            this.gameDetailVisible = true
             this.$nextTick(() => {
                this.$refs.gameDetail.init(id)
            })
        },
        init (id) {
            this.memberId = id
            this.visible = true
            this.getDownGradeRecordData()
            this.getGameTotalData()
        },
        // 每页数
        sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDownGradeRecordData()
        },
        // 当前页
        currentChangeHandle (val) {
        this.pageIndex = val
        this.getDownGradeRecordData()
        },
        // 获取整个比赛统计信息
        getGameTotalData () {
            this.$http({
                url: this.$http.adornUrl(`/mbScore/matchPoint/${this.memberId}`),
                method: 'get'
            }).then(data => { 
                if (data && data.code === 0) {
                   this.objectParams = data.data
                }
            })
        },
        // 获取列表数据
        getDownGradeRecordData () {
             this.$http({
                url: this.$http.adornUrl(`/mbMember/adjustList/${this.memberId}`),
                method: 'get',
                params: this.$http.adornParams({
                    page: this.pageIndex,
                    limit: this.pageSize
                 })
            }).then(data => { 
                if (data && data.code === 0) {
                    this.tableData = data.data.rows
                    this.totalPage = data.data.total
                } else {
                    this.tableData = []
                    this.totalPage = 0
                }
            })
        }
    }
}
</script>
<style scoped>
 .container {
    width: 80%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    flex-wrap: wrap;
 }
</style>